import * as categoryPromoBannerActions from '../../action_creators/category/category_promo_banner_action_creators';
import CategoryPromoBannerModel from '../../../models/category/category_promo_banner';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(categoryPromoBannerActions.categoryPromoBannerLoading({}, store));
    return CategoryPromoBannerModel.fetch(params, store, isTag)
      .then(function handlePostDetailData(resp) {
        dispatch(
          categoryPromoBannerActions.categoryPromoBannerLoaded(resp.data, store)
        );
      })
      .catch(function handleUserError(err) {
        dispatch(
          categoryPromoBannerActions.categoryPromoBannerLoadError(err, store)
        );
        log.error(
          err,
          `Error in categoryPromoBanner actions, message: ${err.message}`
        );
      });
  };
}
